import { render, staticRenderFns } from "./SPKLUReport.vue?vue&type=template&id=2cabc34b"
import script from "./SPKLUReport.vue?vue&type=script&lang=js"
export * from "./SPKLUReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports